import React, { createContext, useContext, useState } from 'react';

export const HeaderContext = React.createContext();

export const VenteContext = React.createContext();